export const LAYER_SUBWAY = 'subway';
export const LAYER_FERRY = 'ferry';
export const LAYER_CITIBIKE = 'citibike';
export const LAYER_WEATHER = 'weather';
export const LAYER_RADAR = 'radar';
export const LAYER_NWS_ALERTS = 'nws_alerts';
export const LAYER_TIDES = 'tides';
export const LAYER_GRID = 'grid_load';
export const LAYER_311 = 'c311';
export const LAYER_FILM = 'film';
export const LAYER_DOT_SPEEDS = 'dot_speeds';
export const LAYER_SERVICE_ALERTS = 'service_alerts';
export const LAYER_BUSES = 'buses';
export const LAYER_LIRR = 'lirr';
export const LAYER_MNR = 'mnr';
export const LAYER_PATH = 'path';
export const LAYER_CAMS = 'cams';
export const LAYER_LINKNYC = 'linknyc';
export const LAYER_FLIGHTS = 'flights';
export const LAYER_AQI = 'aqi';
export const LAYER_FLOODNET = 'floodnet';
export const LAYER_ENE = 'ene';
export const LAYER_AIS = 'ais';
export const LAYER_POWER_OUTAGES = 'power_outages';
export const LAYER_HARBOR = 'harbor';
/** TomTom traffic sampling/rendering extent: west, south, east, north. */
export const NYC_TRAFFIC_BOUNDS = [-74.2591, 40.4774, -73.7004, 40.9176];
export const LAYER_IDS = [
    LAYER_SUBWAY, LAYER_FERRY, LAYER_CITIBIKE, LAYER_WEATHER, LAYER_RADAR,
    LAYER_NWS_ALERTS, LAYER_TIDES, LAYER_GRID, LAYER_311, LAYER_FILM,
    LAYER_DOT_SPEEDS, LAYER_SERVICE_ALERTS, LAYER_BUSES, LAYER_LIRR, LAYER_MNR, LAYER_PATH, LAYER_CAMS,
    LAYER_LINKNYC, LAYER_FLIGHTS, LAYER_AQI, LAYER_FLOODNET, LAYER_ENE, LAYER_AIS,
    LAYER_POWER_OUTAGES, LAYER_HARBOR,
];
